var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5075 4.64981C10.4866 4.44124 10.5096 4.2306 10.5751 4.03147C10.6405 3.83234 10.747 3.64915 10.8876 3.4937C11.0283 3.33825 11.1999 3.214 11.3915 3.12897C11.5831 3.04393 11.7904 3 12 3C12.2096 3 12.4169 3.04393 12.6085 3.12897C12.8001 3.214 12.9717 3.33825 13.1124 3.4937C13.253 3.64915 13.3595 3.83234 13.4249 4.03147C13.4904 4.2306 13.5134 4.44124 13.4925 4.64981L12.9105 14.1748C12.888 14.4007 12.7824 14.6101 12.6141 14.7625C12.4459 14.9148 12.227 14.9992 12 14.9992C11.773 14.9992 11.5541 14.9148 11.3859 14.7625C11.2176 14.6101 11.112 14.4007 11.0895 14.1748L10.5075 4.64981ZM10.5 17.9998C10.5 17.602 10.658 17.2205 10.9393 16.9392C11.2206 16.6578 11.6022 16.4998 12 16.4998C12.3978 16.4998 12.7794 16.6578 13.0607 16.9392C13.342 17.2205 13.5 17.602 13.5 17.9998C13.5 18.3976 13.342 18.7792 13.0607 19.0605C12.7794 19.3418 12.3978 19.4998 12 19.4998C11.6022 19.4998 11.2206 19.3418 10.9393 19.0605C10.658 18.7792 10.5 18.3976 10.5 17.9998Z",
    fill: "#FF9345"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/Exclamation.fc6db722c219a7d82f7caa63a91b6aa8.svg";
export { ForwardRef as ReactComponent };